import React from "react"

import UserIcon from "../../../../../../core/gd-components/icons/user/user"
import {QuickSearchResultProps} from "./@type"
import CompanyUser from "../../../../../../core/model2/company-user-new/company-user"


export default function QuickSearch_ResultUser(props:QuickSearchResultProps) {


    const companyUser : CompanyUser = props.searchResult.item as CompanyUser;

    const classes = Classes("row ui5-list-item", props.className, {
        'selected': props.searchResult.index === props.quickSearch.keyboardIterator.currentIndex
    });

    return (
        <div className={classes} onClick={props.searchResult.onClick}>
            <div className="cell">
                <div className="title">
                    <div className="icon-22 m-r-10">
                        <UserIcon size="22" userId={companyUser.user.id} hint={false}/>
                    </div>
                    <div className="ui5-txt-default max-w-250">{companyUser.user.name}</div>
                </div>

            </div>
            <div className="cell align-r"/>
        </div>
    )


}
